import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../user-home-page/Header'
import { Footer } from '../user-home-page/Footer'
import { FloatingActions } from '../user-home-page/FloatingActions'
import { buildSiteUrl, usePageSeo } from 'src/helpers/usePageSeo'
import { breadcrumbSchema } from 'src/helpers/seoStructuredData'
import { newsArticles } from './newsData'
import { NewsCard, NewsCardBody, NewsGrid, NewsHero, NewsMain, NewsPageWrapper } from './News.styles'

const NewsPage: React.FC = () => {
   usePageSeo({
      title: 'Tin tức xe ghép Thanh Hóa Hà Nội',
      description:
         'Kinh nghiệm đặt xe ghép Thanh Hóa Hà Nội, gửi hàng trong ngày, chọn xe đi công tác và gợi ý điểm đến thực tế cho khách đi tuyến Hà Nội - Thanh Hóa.',
      path: '/news',
      keywords: [
         'tin tức xe ghép Thanh Hóa Hà Nội',
         'kinh nghiệm đi xe ghép',
         'gửi hàng Thanh Hóa Hà Nội',
         'xe đi Hà Nội từ Thanh Hóa'
      ],
      structuredData: [
         {
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: 'Tin tức xe ghép Thanh Hóa Hà Nội',
            description:
               'Tổng hợp kinh nghiệm đi xe ghép, gửi hàng và du lịch tuyến Thanh Hóa - Hà Nội từ LinhLinh36.',
            inLanguage: 'vi-VN',
            mainEntity: newsArticles.map((article) => ({
               '@type': 'Article',
               headline: article.title,
               url: buildSiteUrl(`/news/${article.slug}`),
               datePublished: article.publishedAt,
               dateModified: article.updatedAt
            }))
         },
         breadcrumbSchema([
            { name: 'Trang chủ', path: '/' },
            { name: 'Tin tức', path: '/news' }
         ])
      ]
   })

   return (
      <NewsPageWrapper>
         <Header />
         <NewsMain>
            <NewsHero>
               <h1>Tin tức xe ghép Thanh Hóa Hà Nội</h1>
               <p>
                  Những bài viết ngắn gọn, dễ đọc về cách đặt xe, chọn chuyến, gửi hàng và đi lại giữa Thanh Hóa - Hà
                  Nội. Nội dung bám nhu cầu thật, đọc nhanh nhưng vẫn đủ ý để bạn chuẩn bị chuyến đi đỡ mệt hơn.
               </p>
            </NewsHero>

            <NewsGrid>
               {newsArticles.map((article) => (
                  <NewsCard key={article.slug}>
                     <img src={article.image} alt={article.title} />
                     <NewsCardBody>
                        <span>
                           {article.category} · {article.readTime}
                        </span>
                        <h2>{article.title}</h2>
                        <p>{article.description}</p>
                        <Link to={`/news/${article.slug}`}>Đọc bài viết</Link>
                     </NewsCardBody>
                  </NewsCard>
               ))}
            </NewsGrid>
         </NewsMain>
         <Footer />
         <FloatingActions />
      </NewsPageWrapper>
   )
}

export default NewsPage
